(()=>{
 const root=document.querySelector('#shopify-section-knl-press-squat');
 if(!root)return;
 const hero=root.querySelector('#LandminePressSquatHero');
 const heading=hero?.querySelector('h1');
 if(heading && heading.textContent.trim()==='Landmine Press & Squat'){
  heading.replaceChildren(document.createTextNode('Landmine '));
  const emphasis=document.createElement('span');emphasis.className='lm-hero-em';emphasis.textContent='Press & Squat';heading.append(emphasis);
 }
 hero?.querySelectorAll('a.ks-assurance-item').forEach(link=>{
  const item=document.createElement('div');item.className=link.className;
  while(link.firstChild)item.append(link.firstChild);
  link.replaceWith(item);
 });
 if('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
  const intro=root.querySelector('.lpsa-intro');
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(entry.isIntersecting){entry.target.classList.add('lm-seen');observer.unobserve(entry.target);}
  }),{threshold:.25});
  if(intro)observer.observe(intro);
 }
})();
